export default __webpack_public_path__ + "static/media/solution_44.5018b38d.svg";